import {useAuthenticationContext} from "../contexts/authenticationcontext";
import {useForm} from "../utilities/formutilities";
import {useCallback, useState} from "react";
import {useNavigate} from "react-router-dom";
import {PageMainBody} from "../components/PageMainBody";
import {Button, CloseButton, Col, Form, FormControl, FormLabel, Row} from "react-bootstrap";
import {PasswordControl, UsernameControl} from "../components/controls/FormControls";
import {BasePageLayout} from "../components/grouping/BasePageLayout";
import {RESETPASSWORD_EMPTY, useResetPasswordMutations} from "../api/resetpasswordsapi";

export function LoginPage() {
    const [showLogin, setShowLogin] = useState(true);
    const initialObjectInitializer = useCallback(() => ({username: "", password: ""}), []);
    const {tempObject, onChange, resetTempObject} = useForm(initialObjectInitializer);
    const {isLoggedIn, authenticate, username} = useAuthenticationContext();

    const navigate = useNavigate();

    async function handleSubmit(e) {
        e.preventDefault();
        const result = await authenticate(tempObject.username, tempObject.password);
        if (result) navigate("/", {replace: true});
    }

    if (isLoggedIn) return <div className="text-center m-5">logged in as {username}</div>;
    return <> <BasePageLayout>
        <PageMainBody>
            <Row className={"g-0 justify-content-center"}>
                <Col xs={12} className={'text-center'}>
                    <h3>{showLogin ? "Login" : "Reset je wachtwoord"}</h3>
                </Col>
                <Col xs={12} md={6} xl={3}>
                    {showLogin ?
                        <Form className={"text-start"}
                              onSubmit={e => handleSubmit(e)}>
                            <UsernameControl onChange={onChange} tempObject={tempObject}/>
                            <PasswordControl onChange={onChange} tempObject={tempObject}/>
                            <a href={"#"} onClick={() => setShowLogin(false)}>Reset je wachtwoord</a>
                            <Col className={"text-center mb-4"}>
                                <Button type={"submit"}>Login</Button>
                            </Col>
                        </Form>
                        :
                        <ResetPasswordForm showLogin={showLogin} onShowLoginChanged={setShowLogin}/>}
                </Col>
            </Row>
        </PageMainBody>
    </BasePageLayout>

    </>
}

function ResetPasswordForm(props) {
    const [requestSucces, setRequestSucces] = useState(false);
    const [requestFail, setRequestFail] = useState(false);
    const {onShowLoginChanged} = props;
    const initialObjectInitializer = useCallback(() => ({...RESETPASSWORD_EMPTY, emailRepeat: ""}), []);
    const {onChange, tempObject, setTempObject} = useForm(initialObjectInitializer);
    const {createResetPassword} = useResetPasswordMutations();

    async function handleSubmit(e) {
        const result = await createResetPassword(tempObject)
        if (result) {
            setRequestSucces(true);
            setTempObject({...RESETPASSWORD_EMPTY, emailRepeat: ""})
            setRequestFail(false);
        } else {
            setRequestFail(true);
        }
    }

    return <>

        <Col xs={12} className={'text-end'}>
            <CloseButton onClick={() => onShowLoginChanged(true)}/>

        </Col>
        <Col xs={12}>
            <FormLabel>Lidnummer</FormLabel>
            <FormControl value={tempObject.memberNumber} type={'number'} placeholder={"Lidnummer"}
                         onChange={e => onChange(e, "memberNumber")}/>
            <FormLabel>Email</FormLabel>
            <FormControl value={tempObject.email} type={'email'} placeholder={"Email"}
                         onChange={e => onChange(e, 'email')}/>
            <FormLabel>Herhaal email</FormLabel>
            <FormControl value={tempObject.emailRepeat} type={'email'} placeholder={"Herhaal je email"}
                         onChange={e => onChange(e, 'emailRepeat')}/>
            {tempObject.emailRepeat !== tempObject.email && tempObject.emailRepeat !== "" ?
                <p>Emails komen niet overeen</p> : ""}

        </Col>
        {requestFail ? "Er ging iets mis met het verzenden. Het kan zijn dat dit email niet gekoppeld is aan jouw account!" : ""}
        <p>{requestSucces ? "Er is een mail verstuurd met een link voor je wachtwoord te resetten." : ""}</p>
        <p>{requestSucces ? "Je mag dit venster sluiten door op het kruisje te drukken." : ""}</p>

        <Col xs={12} className={'text-end'}>
            <Button
                disabled={tempObject.email !== tempObject.emailRepeat || tempObject.email === "" || tempObject.memberNumber === ""}
                className={'mt-2 mb-4'} onClick={e => handleSubmit(e)}>Reset</Button>
        </Col>
        <Col></Col>
    </>


}